<template>
    <!-- <b-row class="mb-1">
		<b-col sm="12" :md="md" :lg="lg" :xl="xl" class="text-right pr-1">{{ titulo }}</b-col>
		<b-col sm="12" :md="mddiff" :lg="lgdiff" :xl="xldiff" class="pl-1">
			<slot></slot>
		</b-col>
	</b-row> -->
    <div>
        <b-row class="mb-1" v-if="$mq == 'xl'">
            <div class="col pr-0" :style="`flex: 0 0 ${size}px !important`">
                <div class="text-right">
                    {{ titulo }}
                </div>
            </div>
            <div class="col">
                <div>
                    <slot></slot>
                </div>
            </div>
        </b-row>
        <b-row class="mb-1" v-if="$mq != 'xl'">
            <div class="col-12">
                <div>
                    {{ titulo }}
                </div>
            </div>
            <div class="col-12">
                <div>
                    <slot></slot>
                </div>
            </div>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'DetalheComponent',
    props: {
        titulo: {
            type: String,
            default: ''
        },

        size: {
            type: String,
            default: '100'
        },

        md: {
            type: Number,
            default: 4
        },

        lg: {
            type: Number,
            default: 4
        },

        xl: {
            type: Number,
            default: 2
        }
    },

    methods: {},

    computed: {
        mddiff() {
            return 12 - this.md
        },

        lgdiff() {
            return 12 - this.lg
        },

        xldiff() {
            return 12 - this.xl
        }
    }
}
</script>
